import type { ReactNode } from 'react';
import styles from './Pill.module.css';

type PillProps = {
  children: ReactNode;
  variant?: 'solid' | 'ghost' | 'ghostOnDark';
  /** Override bg — accepts any CSS color, including var(--c-training) etc. */
  bg?: string;
  fg?: string;
  className?: string;
};

/**
 * Small uppercase tag/chip. Used for coach names ("Training"), category
 * tags ("Easy", "Tempo"), and any compact label.
 *
 * Default solid is ink-900 bg / paper fg.
 * Override bg/fg for coach-tinted pills (e.g. <Pill bg="var(--c-training)">Training</Pill>).
 */
export function Pill({
  children,
  variant = 'solid',
  bg,
  fg,
  className,
}: PillProps) {
  return (
    <span
      className={[styles.pill, styles[variant], className].filter(Boolean).join(' ')}
      style={{
        ...(bg ? { background: bg } : {}),
        ...(fg ? { color: fg } : {}),
      }}
    >
      {children}
    </span>
  );
}
